import classNames from "classnames";
import { Constants } from "../../../../../../common/constants";
import { RemovingThrobber } from "../../removing_throbber";
import {
	ButtonProps,
	SeshAddonInput,
} from "../base_components/sesh_addon_input";

export function PageButtons(props: {
	page: number;
	total_items: number;
	setPage: (num: number) => void;
	is_loading: boolean;
	items_per_page: number;
}) {
	const buttons: ButtonProps<number>[] = [];

	const total_pages = Math.ceil(props.total_items / props.items_per_page);

	const numbered_buttons = 2;

	const page_index = props.page;

	if (props.page > total_pages) {
		props.setPage(total_pages - 1);
	}

	for (
		let i = page_index - numbered_buttons;
		i < page_index + numbered_buttons + 1;
		i++
	) {
		let current_page_num = i;
		if (current_page_num < 0) {
			current_page_num = page_index + numbered_buttons + Math.abs(i);
		}

		if (current_page_num >= total_pages) {
			const diff = current_page_num - (total_pages - 1);
			current_page_num = page_index - numbered_buttons - diff;
		}

		if (current_page_num >= total_pages || current_page_num < 0) {
			continue;
		}

		buttons.push({
			label: (current_page_num + 1).toString(),
			value: current_page_num,
		});
	}

	return (
		<div className="flex flex-col items-center gap-2">
			<div className="flex items-center gap-2">
				<div
					className={classNames({
						invisible: !props.is_loading,
					})}
				>
					<RemovingThrobber />
				</div>
				<SeshAddonInput
					is_disabled={props.is_loading}
					value={props.page}
					setValue={props.setPage}
					buttons={[
						{
							label: "<",
							value: Math.max(props.page - 1, 0),
							disable_selected_state: true,
						},
						...buttons.sort((a, b) => a.value - b.value),
						{
							label: ">",
							value: Math.min(props.page + 1, total_pages - 1),
							disable_selected_state: true,
						},
					]}
				/>
			</div>
			<div>
				Showing {props.page * props.items_per_page}-
				{Math.min(
					(props.page + 1) * props.items_per_page,
					props.total_items
				)}{" "}
				of {props.total_items}
			</div>
		</div>
	);
}
